module.exports = __webpack_public_path__ + "static/img/jigou-fujian-bottom.8e548f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jigou/jigou-fujian-bottom.png
// module id = u9Be
// module chunks = 2